import { Component, Input, OnInit } from '@angular/core';
import { CommonsText } from 'app/commons/CommonsText';
import { EventService } from 'app/services/event-service';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-pagos-parte',
    templateUrl: './pagos-parte.component.html',
    styleUrls: ['./pagos-parte.component.scss']
})
export class PagosParteComponent implements OnInit {

    @Input() data: any;
    pagos: any[] = undefined;
    flag: boolean = false;

    constructor(
        private eventService: EventService,
        private toastr: ToastrService
    ) {}

    ngOnInit() {
        this.traerPagos();
    }

    traerPagos() {
        if (!this.flag) {
            this.flag = true;
            this.eventService.getPayments(this.data.eventNumber)
                .then(value => {
                    this.pagos = value.response || [];
                })
                .catch(error => {
                    this.pagos = [];
                    this.toastr.error(CommonsText.PROBLEMA_SERVICIO_PAGOS, CommonsText.PROBLEMA_DE_CONECTIVIDAD, {
                        timeOut: 5000
                    });
                });
        }
    }
}
